import { render, staticRenderFns } from "./URLResultBody.vue?vue&type=template&id=4dd01dba&scoped=true&"
import script from "./URLResultBody.vue?vue&type=script&lang=js&"
export * from "./URLResultBody.vue?vue&type=script&lang=js&"
import style0 from "./URLResultBody.vue?vue&type=style&index=0&id=4dd01dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd01dba",
  null
  
)

export default component.exports